<template>
  <ListeReferentiel
    ref="liste"
    titre="Types de service"
    icone="bi-gear-fill"
    ressource="type_services"
    tri-defaut="ts.nom"
    :options-tri="{ Nom: 'ts.nom', Statut: 'ts.isEnabled' }"
    placeholder="Nom ou description…"
    unite="type(s)"
    vide="Aucun type de service enregistré."
    :colonnes="5"
    :peut-creer="$store.getters.hasPermission('CONFIG_CREER_TYPE_SERVICE')"
    libelle-creer="Nouveau type"
    @creer="creation"
  >
    <template #entete>
      <th>Nom</th>
      <th class="d-none d-md-table-cell">Description</th>
      <th>Statut</th>
      <th>Actions</th>
    </template>
    <template #ligne="{ ligne: type }">
      <td>{{ type.nom }}</td>
      <td class="d-none d-md-table-cell">{{ type.description || '—' }}</td>
      <td>
        <span :class="['badge', type.isEnabled ? 'bg-success' : 'bg-secondary']">{{ type.isEnabled ? 'Activé' : 'Désactivé' }}</span>
      </td>
      <td>
        <div v-if="$store.getters.hasAnyPermission(['CONFIG_MODIFIER_TYPE_SERVICE', 'CONFIG_SUPPRESSION_TYPE_SERVICE'])" class="dropdown">
          <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" v-dropdown-fixed>Actions</button>
          <ul class="dropdown-menu">
            <li v-if="$store.getters.hasPermission('CONFIG_MODIFIER_TYPE_SERVICE')"><a class="dropdown-item" href="#" @click.prevent="modifier(type.id)">Modifier</a></li>
            <li v-if="$store.getters.hasPermission('CONFIG_SUPPRESSION_TYPE_SERVICE')"><a class="dropdown-item text-danger" href="#" @click.prevent="supprimer(type)">Supprimer</a></li>
          </ul>
        </div>
      </td>
    </template>
  </ListeReferentiel>
</template>

<script>
import ListeReferentiel from '@/components/commun/ListeReferentiel.vue';

export default {
  name: 'ListeTypeService',
  components: { ListeReferentiel },
  methods: {
    creation() {
      this.$router.push({ name: 'create_type_service' });
    },
    modifier(id) {
      this.$router.push({ name: 'edit_type_service', params: { id } });
    },
    supprimer(type) {
      this.$refs.liste.supprimer({
        id: type.id,
        titre: 'Supprimer le type de service',
        message: `Supprimer le type de service « ${type.nom} » ?`,
        succes: 'Type de service supprimé.',
      });
    },
  },
};
</script>
